export default "/images/silent-hill-lumbering.png";